import { Link as RouterLink, useHistory } from "react-router-dom";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { ResendCode, Verify } from "../../redux/actions/userActions";

import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

import AuthShell from "../auth/AuthShell";
import Spinner from "../common/Spinner";

const VerifyPage = ({ match }) => {
  const history = useHistory();
  const token = match.params.token;
  const [submitted, setSubmitted] = useState(false);
  const dispatch = useDispatch();
  const [showResend, setShowResend] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formState, setFormState] = useState({ values: {} });

  const handleChange = (event) => {
    setFormState((fs) => ({
      ...fs,
      values: { ...fs.values, [event.target.name]: event.target.value },
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    const { code } = formState.values;
    if (!code || !token) return;

    setLoading(true);
    dispatch(Verify(code, token)).then((response) => {
      setLoading(false);
      if (response?.message === "Invalid Code") {
        setShowResend(true);
      } else if (
        response?.message === "User Verified successfully." ||
        response?.message === "User Already Verified."
      ) {
        history.push("/login");
      }
    });
  };

  const handleResendCode = () => {
    if (!token) return;
    setLoading(true);
    dispatch(ResendCode(token)).then(() => setLoading(false));
  };

  return (
    <>
      <AuthShell
        title="Check your inbox"
        subtitle="Enter the verification code we sent to your email."
        footer={
          <Typography variant="body2" align="center" sx={{ color: "text.secondary" }}>
            <Link component={RouterLink} to="/login" sx={{ fontWeight: 700 }}>
              Back to sign in
            </Link>
          </Typography>
        }
      >
        <form onSubmit={handleSubmit} autoComplete="off" noValidate>
          <Stack spacing={2.5}>
            <TextField
              label="Verification code"
              name="code"
              required
              fullWidth
              autoFocus
              autoComplete="one-time-code"
              inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
              value={formState.values.code || ""}
              onChange={handleChange}
              error={submitted && !formState.values.code}
              helperText={submitted && !formState.values.code ? "Code is required" : " "}
            />

            <Button type="submit" variant="contained" size="large" fullWidth disabled={loading}>
              {loading ? "Verifying…" : "Verify"}
            </Button>

            {showResend && (
              <Stack direction="row" justifyContent="center">
                <Link component="button" type="button" onClick={handleResendCode} sx={{ fontWeight: 600 }}>
                  Resend code
                </Link>
              </Stack>
            )}
          </Stack>
        </form>
      </AuthShell>

      {loading && <Spinner fullscreen label="Verifying…" />}
    </>
  );
};

export default VerifyPage;
